/**
 * @generated SignedSource<<b166943e311fea372a1bfa05a2574417>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectTypePicker$data = {
  readonly allJiraProjectTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly key: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ProjectTypePicker";
};
export type ProjectTypePicker$key = {
  readonly " $data"?: ProjectTypePicker$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectTypePicker">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ProjectTypePicker",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraProjectTypeDetailsConnection",
      "kind": "LinkedField",
      "name": "allJiraProjectTypes",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraProjectTypeDetailsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraProjectTypeDetails",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "key"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "8d0276ed63ce855a98e2a058eee00048";

export default node;
